module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "taco-container"
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.liveTransaction.details.clients) + " " + _vm._s(_vm.lender) + " Documents\n\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 8,
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.name,
      on: {
        "click": function($event) {
          return _vm.setLender(lender.name)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    key: "general",
    on: {
      "click": function($event) {
        return _vm.setLender('General')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("General Options")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.showEmail
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email Client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.goToTransaction
          }
        }, on), [_c('v-icon', [_vm._v("ballot")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Go to Transaction")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Transaction")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "taco-content"
  }, [_c('v-col', {
    staticClass: "no-print taco-column",
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px 15px 20px"
    }
  }, [_c('v-text-field', {
    ref: "searchText",
    attrs: {
      "hide-details": "",
      "label": "Search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category['.key'],
      staticStyle: {
        "padding": "3px 10px 3px 10px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "1.3em",
        "padding": "0px 10px 0px 10px"
      }
    }, [_c('v-btn', {
      staticClass: "primary--text",
      staticStyle: {
        "float": "right",
        "margin-top": "-5px"
      },
      attrs: {
        "icon": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDialog(null, category)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "2.1em"
      }
    }, [_vm._v("add_circle")])], 1), _vm._v("        \n        " + _vm._s(category.name) + "\n    ")], 1), _vm._v(" "), _c('div', {
      staticClass: "hide-scroll",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "hide-scroll-inner",
      staticStyle: {
        "max-height": "196px"
      }
    }, _vm._l((_vm.requirementsForCategory(category.name)), function(requirement) {
      return _c('div', {
        key: requirement['.key']
      }, [_c('div', {
        staticClass: "truncate pa-2 ma-2 border-grey hoverable clickable",
        class: {
          'blue-hilight': _vm.collectionContainsKey(_vm.selectedItems, requirement['.key'])
        },
        on: {
          "click": function($event) {
            return _vm.itemClicked(requirement)
          }
        }
      }, [_vm._v("\n            " + _vm._s(requirement.name) + "\n        ")])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "taco-column",
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(_vm.selectedItemsSorted.length == 0) ? _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "margin-top": "30px",
      "width": "100%",
      "text": "align:center"
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    staticStyle: {
      "font-size": "300px"
    }
  }, [_vm._v("layers")]), _vm._v(" "), _c('p', {
    staticClass: "grey--text text--lighten-1",
    staticStyle: {
      "margin": "20px",
      "font-size": "1.3em"
    }
  }, [_vm._v("No items. Click on the document types to the left to start your list")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "checklist"
  }, [_vm._l((_vm.selectedItemsSorted), function(item) {
    return [_c('div', {
      key: item['.key'],
      staticClass: "border-transparent transition clickable hoverable",
      class: {
        'blue-hilight': item['.key'] == _vm.activeItem
      },
      staticStyle: {
        "color": "#444",
        "padding": "7px 15px 7px 15px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.listItemClicked(item)
        }
      }
    }, [(!item.notRequired) ? [(!item.received && !item.checked) ? [_c('b', {
      staticStyle: {
        "margin-bottom": "2px"
      }
    }, [(item.flag) ? _c('span', [_vm._v("(" + _vm._s(item.flag) + ") ")]) : _vm._e(), _vm._v(_vm._s(item.name))]), _vm._v(" "), (!item.received && !item.checked) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkorange",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(item.requirementName))]) : _vm._e(), _vm._v(" "), (item.description) ? [_c('br'), _vm._v(" " + _vm._s(item.description) + "\n                        ")] : _vm._e(), _vm._v(" "), (item.note) ? [_c('br'), _c('span', {
      staticStyle: {
        "padding": "2px 5px 2px 5px",
        "background-color": "yellow"
      }
    }, [_vm._v(_vm._s(item.note))])] : _vm._e(), _vm._v(" "), (item.download) ? [_c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": item.download,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return false($event)
        }
      }
    }, [_c('button', {
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "0px",
        "color": "#444",
        "background-color": "white",
        "border-radius": "3px",
        "border": "solid 1px #c0c0c0",
        "padding": "5px 18px 5px 18px",
        "user-select": "none"
      }
    }, [_vm._v("Download")])])] : _vm._e()] : [_c('b', {
      staticStyle: {
        "margin-bottom": "2px",
        "color": "#444"
      }
    }, [(item.flag) ? _c('span', [_vm._v("(" + _vm._s(item.flag) + ") ")]) : _vm._e(), _vm._v(_vm._s(item.name))]), _vm._v(" "), (item.received) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkgreen",
        "padding-top": "2px",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("Received")]) : _vm._e(), _vm._v(" "), (item.checked) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkgreen",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("Checked")]) : _vm._e(), _vm._v(" "), (_vm.documentExpired(item)) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkred",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm.documentExpired(item)))]) : _vm._e()]] : [_c('i', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(item.description))])]], 2)]
  })], 2), _vm._v(" "), (_vm.selectedItems.length) ? _c('v-btn', _vm._g({
    attrs: {
      "dark": "",
      "rounded": "",
      "color": "blue lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyToClipboard($event)
      }
    }
  }, _vm.on), [_vm._v("\n        Copy to Clipboard\n    ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "rounded": "",
            "color": "blue lighten-2"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.showEmail($event)
            }
          }
        }, on), [_vm._v("\n            Copy to Clipboard\n        ")]) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email to Client")])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), (_vm.transactionKey) ? _c('v-col', {
    staticClass: "pa-3 no-print",
    attrs: {
      "md": "4",
      "sm": "12",
      "row": ""
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Next Followup")]), _vm._v("\n    " + _vm._s(_vm._f("dueString")(_vm.followUpTask.due)) + "\n    "), _c('Scheduler', {
    on: {
      "change": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.due),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "due", $$v)
      },
      expression: "followUpTask.due"
    }
  }), _vm._v(" "), _c('UserChooser', {
    attrs: {
      "label": "Assigned To"
    },
    on: {
      "select": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.assigned),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "assigned", $$v)
      },
      expression: "followUpTask.assigned"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heading mt-4 mb-2"
  }, [_vm._v("Checklist Comments")]), _vm._v(" "), _c('TransactionComments')], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "id": "mobile-tabs-1",
      "dark": ""
    },
    model: {
      value: (_vm.dialogTab),
      callback: function($$v) {
        _vm.dialogTab = $$v
      },
      expression: "dialogTab"
    }
  }, [_c('v-tab', {
    key: 1
  }, [_vm._v("\n                Details\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 2
  }, [_vm._v("\n                Advanced\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 3
  }, [_vm._v("\n                Checklist\n            ")]), _vm._v(" "), _c('v-tab-item', {
    key: 1
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "name": "document-name",
      "label": "Document Name"
    },
    model: {
      value: (_vm.documentName),
      callback: function($$v) {
        _vm.documentName = $$v
      },
      expression: "documentName"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "rows": "3",
      "name": "document-description",
      "label": "Description"
    },
    model: {
      value: (_vm.documentDescription),
      callback: function($$v) {
        _vm.documentDescription = $$v
      },
      expression: "documentDescription"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-note",
      "label": "Special Note",
      "hide-details": ""
    },
    model: {
      value: (_vm.documentNote),
      callback: function($$v) {
        _vm.documentNote = $$v
      },
      expression: "documentNote"
    }
  }), _vm._v(" "), _c('br'), _vm._v("Flag   \n                    "), _c('v-btn-toggle', {
    attrs: {
      "text": ""
    },
    model: {
      value: (_vm.documentFlag),
      callback: function($$v) {
        _vm.documentFlag = $$v
      },
      expression: "documentFlag"
    }
  }, [_c('v-btn', {
    key: "LATER",
    attrs: {
      "text": "",
      "value": "LATER"
    }
  }, [_vm._v("Later")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    attrs: {
      "text": "",
      "value": _vm.client1
    }
  }, [_vm._v(_vm._s(_vm.client1))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    attrs: {
      "text": "",
      "value": _vm.client2
    }
  }, [_vm._v(_vm._s(_vm.client2))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    key: "BOTH",
    attrs: {
      "text": "",
      "value": "BOTH"
    }
  }, [_vm._v("Both")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-switch', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "color": "primary",
      "xhide-details": "",
      "label": "Received"
    },
    model: {
      value: (_vm.documentReceived),
      callback: function($$v) {
        _vm.documentReceived = $$v
      },
      expression: "documentReceived"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "color": "primary",
      "hide-details": "",
      "label": "Checked"
    },
    model: {
      value: (_vm.documentChecked),
      callback: function($$v) {
        _vm.documentChecked = $$v
      },
      expression: "documentChecked"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": true,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Document Date",
            "value": _vm.documentDateString,
            "prepend-icon": "event",
            "readonly": ""
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.dialogDateMenu),
      callback: function($$v) {
        _vm.dialogDateMenu = $$v
      },
      expression: "dialogDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    model: {
      value: (_vm.documentDate),
      callback: function($$v) {
        _vm.documentDate = $$v
      },
      expression: "documentDate"
    }
  }, [
    [_c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "-50px"
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.documentDate = null
        }
      }
    }, [_vm._v("Clear")])], 1)]
  ], 2)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-tab-item', {
    key: 2
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "document-download",
      "label": "Download Link"
    },
    model: {
      value: (_vm.documentDownload),
      callback: function($$v) {
        _vm.documentDownload = $$v
      },
      expression: "documentDownload"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-expiry-days",
      "label": "Days to Expire"
    },
    model: {
      value: (_vm.documentExpiryDays),
      callback: function($$v) {
        _vm.documentExpiryDays = $$v
      },
      expression: "documentExpiryDays"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "8",
      "name": "document-description",
      "label": "Instructions"
    },
    model: {
      value: (_vm.documentInstructions),
      callback: function($$v) {
        _vm.documentInstructions = $$v
      },
      expression: "documentInstructions"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-tab-item', {
    key: 3
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_vm._l((_vm.documentChecklist), function(check, index) {
    return _c('div', {
      key: check.text
    }, [_c('DeleteButton', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.documentChecklist.splice(index, 1)
        }
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "hide-details": "",
        "label": 'Check ' + (index + 1)
      },
      model: {
        value: (check.text),
        callback: function($$v) {
          _vm.$set(check, "text", $$v)
        },
        expression: "check.text"
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Add Check Item"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCheckItem($event)
      }
    },
    model: {
      value: (_vm.newCheckItem),
      callback: function($$v) {
        _vm.newCheckItem = $$v
      },
      expression: "newCheckItem"
    }
  })], 1)], 2)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.documentKey) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteRequirement(_vm.documentKey)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000
    },
    model: {
      value: (_vm.snackbarshow),
      callback: function($$v) {
        _vm.snackbarshow = $$v
      },
      expression: "snackbarshow"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar) + "\n    "), _c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("assignment_turned_in")])], 1), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), _c('SupplierDocumentDialog', {
    attrs: {
      "settings": _vm.supplierDocumentDialog.settings,
      "document": _vm.supplierDocumentDialog.document
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc78492c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/SupplierChecklist.vue
// module id = 2670
// module chunks = 1